import { APP_ENVS } from '@savgroup-front-common/constants';

export const getPurseEnvironment = (appEnv: APP_ENVS) => {
  switch (appEnv) {
    case APP_ENVS.PROD:
      return 'production';
    case APP_ENVS.DEV:
      return 'development';
    case APP_ENVS.DEMO:
      return 'sandbox';
    case APP_ENVS.TEST:
      return 'test';
    default:
      return 'sandbox';
  }
};

export const getPursePublicEnvironment = (appEnv: APP_ENVS) => {
  switch (appEnv) {
    case APP_ENVS.PROD:
      return 'production';

    case APP_ENVS.LOCAL:
    case APP_ENVS.DEV:
    case APP_ENVS.DEMO:
    case APP_ENVS.TEST:
    default:
      return 'sandbox';
  }
};
